<template>
  <v-snackbar v-model="snackbar" :color="type" top>
    <v-row justify="space-between" align="center">
      <div class="pa-2 subtitle-1">{{ message }}</div>
      <div @click="hideAlert" class="pointer">
        <v-icon>mdi_clear</v-icon>
      </div>
    </v-row>
  </v-snackbar>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    name: 'TheAlert',
    data() {
      return {
        snackbar: true,
      };
    },
    computed: {
      ...mapState('alert', ['message', 'type']),
    },
    methods: {
      ...mapActions('alert', ['hideAlert']),
    },
  };
</script>

<style lang="scss" scoped>
  .pointer {
    cursor: pointer;
  }
</style>
